import React, { useState, useEffect, useCallback } from 'react'
import './audit-notice-detail.less'
import { setHeader } from '@/util/set-header'
import { List } from 'antd-mobile'
import {
  setreadNoticeApi,
  noticedetailApi,
  noticeChangeStatusApi,
} from '@/api/user-infomation'
import { Toast } from 'antd-mobile'
import { getAuth } from '@/util/storage'
const auth = getAuth()
const Item = List.Item
const Brief = Item.Brief

function AuditNoticeDetail({ match, history }: any) {
  const [title, setTitle]: any = useState()
  const [status_text, setStatus_text]: any = useState()
  const [main, setMain]: any = useState()
  const [audit_info, setAudit_info]: any = useState()
  const [type, setType]: any = useState()
  //合同明细
  const [contract_detail_content, setContract_detail]: any = useState()
  //合同附件
  const [contract_attachment, setContract_attachment]: any = useState()
  //归档附件
  const [file_attachment, setFile_attachment]: any = useState()
  const [status, setStatus]: any = useState()
  const [id, setId]: any = useState()
  //驳回意见
  const [reason, setReason]: any = useState()
  const parentId = match.params.id
  const formType = match.params.type

  const fetchNoticedetail = useCallback(async () => {
    Toast.loading('加载中', 0)
    const url =
      formType === 'list'
        ? `/mall/notice/app/detail.json`
        : `/mall/notice/push/detail.json`
    const { data } = await noticedetailApi(url, { id: parentId })
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 3)
      return false
    }
    const {
      title,
      status_text,
      main,
      audit_info,
      type,
      contract_detail_content,
      contract_attachment,
      status,
      id,
      file_attachment,
      reason,
      app_notice_id,
    } = data.data
    setTitle(title)
    setStatus_text(status_text)
    setMain(main)
    setAudit_info(audit_info)
    setType(type)
    setContract_detail(contract_detail_content)
    setContract_attachment(contract_attachment)
    setStatus(status)
    setId(id)
    setFile_attachment(file_attachment)
    setReason(reason)
    //设置消息已阅读
    setreadNoticeApi({ id: app_notice_id })
  }, [parentId, formType])

  useEffect(() => {
    const leftClick = () => {
      if (history.length > 1) {
        history.goBack()
      } else {
        if (window.WebViewBridge) {
          window.WebViewBridge.navBackMarket()
        } else if (window.webkit) {
          window.webkit.messageHandlers.navBackMarket.postMessage('')
        }
      }
    }
    setHeader({ title: '通知详情', leftClick })
    //获取消息详情
    fetchNoticedetail()
  }, [parentId, fetchNoticedetail, history])

  //审核通过
  const passClick = async () => {
    let formData: any = new FormData()
    formData.append('id', id)
    formData.append('type', type)
    formData.append('status', 'audit')
    formData.append('auth', auth)
    Toast.loading('加载中', 0)
    const { data } = await noticeChangeStatusApi(formData)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 2)
      return
    }
    Toast.info('已处理', 2)
    if (window.WebViewBridge?.eventLabel) {
      window.WebViewBridge?.eventLabel('PLDC01', '')
    } else if (window.webkit) {
      window.webkit.messageHandlers.eventLabel.postMessage({ id: 'PLDC01' })
    }
    if (type === 'quit') {
      setStatus('audit')
      setStatus_text('已审核')
    } else if (type === 'contract') {
      setStatus('')
      setStatus_text('')
    }
  }
  //驳回
  const turnDown = (id: string, type: string) => {
    if (window.WebViewBridge?.eventLabel) {
      window.WebViewBridge?.eventLabel('PLDC02', '')
    } else if (window.webkit) {
      window.webkit.messageHandlers.eventLabel.postMessage({ id: 'PLDC02' })
    }
    history.push({
      pathname: '/notice/dismiss-opinion',
      state: { id, type },
    })
  }
  return (
    <div className="audit-notice-detail">
      <div className="audit-notice-main">
        <List>
          <Item multipleLine>
            <h5> {title}</h5>
            <Brief>
              <span
                style={{ color: status === 'audit' ? '#e5004f' : '#f29803' }}
              >
                {status_text}
              </span>
            </Brief>
          </Item>
          <div className="border-no">
            {main?.map((item: any, i: number) => {
              return (
                <Item
                  extra={
                    <span className="f_color_black font-7">{item.detail}</span>
                  }
                  data-seed="logId"
                  wrap
                  key={i}
                >
                  <span className="font-6"> {item.title}</span>
                </Item>
              )
            })}
          </div>
          <div className={type !== 'contract' ? 'border-no' : ''}>
            {audit_info?.map((item: any, i: number) => {
              return (
                <Item
                  extra={
                    <span className="f_color_black font-7">{item.detail}</span>
                  }
                  data-seed="logId"
                  wrap
                  key={i}
                >
                  <span className="font-7"> {item.title}</span>
                </Item>
              )
            })}
          </div>
        </List>

        {contract_attachment && (
          //合同附件
          <List style={{ marginTop: '0.15rem' }}>
            <Item>
              <h5> 合同附件</h5>
            </Item>
            <div className="border-no">
              {contract_attachment?.map((item: any, i: number) => {
                return (
                  <Item
                    arrow="horizontal"
                    data-seed="logId"
                    key={i}
                    onClick={() => (window.location.href = item.file_path)}
                  >
                    <span className="font-7"> {item.file_name}</span>
                  </Item>
                )
              })}
            </div>
          </List>
        )}
        {file_attachment && (
          //归档附件
          <List style={{ marginTop: '0.15rem' }}>
            <Item>
              <h5> 归档附件</h5>
            </Item>
            <div className="border-no">
              {file_attachment?.map((item: any, i: number) => {
                return (
                  <Item
                    arrow="horizontal"
                    data-seed="logId"
                    key={i}
                    onClick={() => (window.location.href = item.file_path)}
                  >
                    <span className="font-7"> {item.file_name}</span>
                  </Item>
                )
              })}
            </div>
          </List>
        )}
        {contract_detail_content && (
          //合同明细
          <List style={{ marginTop: '0.15rem' }}>
            <Item>
              <h5> 合同明细</h5>
            </Item>
            <div className="border-no">
              {contract_detail_content?.map((item: any, i: number) => {
                return (
                  <Item
                    arrow="horizontal"
                    data-seed="logId"
                    key={i}
                    onClick={() =>
                      history.push(`/notice/contract-details/${item.id}`)
                    }
                  >
                    <span className="font-7"> {item.title}</span>
                  </Item>
                )
              })}
            </div>
          </List>
        )}
        {status === 'refused' && (
          //驳回意见
          <List style={{ marginTop: '0.15rem' }}>
            <Item>
              <h5> 驳回意见</h5>
            </Item>
            <div className="border-no">
              <Item wrap>
                <span className="font-7"> {reason}</span>
              </Item>
            </div>
          </List>
        )}
      </div>
      {status === 'wait' && (
        <div className="audit-notice-but font-3">
          <div onClick={() => turnDown(id, type)}>驳回</div>
          <div onClick={passClick}>通过</div>
        </div>
      )}
    </div>
  )
}

export default AuditNoticeDetail
